export const Actions = {
  INITIATE_AUTH: "INIT_AUTH",
  INIT_GET_LEAD: "INIT_GET_LEAD",
  INIT_CREATE_LEAD: "INIT_CREATE_LEAD",
  INIT_UPDATE_LEAD: "INIT_UPDATE_LEAD",
  INIT_UPDATE_RESIDENCY: "INIT_UPDATE_RESIDENCY",
  INIT_UPDATE_BANK_DETAILS: "INIT_UPDATE_BANK_DETAILS",
  INIT_DAY_CARE_DETAILS: "INIT_DAY_CARE_DETAILS",
  INIT_RENTAL_INCOME_DETAILS: "INIT_RENTAL_INCOME_DETAILS",
  INIT_SELF_EMPLOYMENT: "INIT_SELF_EMPLOYMENT",
  INIT_ESTIMATED_TAX_PAYER: "INIT_ESTIMATED_TAX_PAYER",
  INTI_FBAR_FATCA: "INTI_FBAR_FATCA",
  INIT_OTHER_INCOME: "INIT_OTHER_INCOME",
  INIT_ADJUSTMENT_INCOME: "INIT_ADJUSTMENT_INCOME",
  INIT_MEDICAL_EXPENSE: "INIT_MEDICAL_EXPENSE",
  INIT_TAX_PAID: "INIT_TAX_PAID",
  INIT_DOCUMENTS: "INIT_DOCUMENTS",
  INIT_GET_COMMENTS: "INIT_GET_COMMENTS",
  INIT_GET_REVIEWS: "INIT_GET_REVIEWS",
  INIT_CREATE_COMMENT: "INIT_CREATE_COMMENT",
  INIT_CREATE_REVIEW: "INIT_CREATE_REVIEW",
  INIT_REOPEN_LEAD: "INIT_REOPEN_LEAD",
  INIT_DELETE_LEAD: "INIT_DELETE_LEAD",
  INIT_SUBMIT_TAX_FILE: "INIT_SUBMIT_TAX_FILE",
  INIT_SIGNATURE: "INIT_SIGNATURE",
  INIT_RESEND_OTP: "INIT_RESEND_OTP",
  INIT_SUBMIT_OTP: "INIT_SUBMIT_OTP",
  INIT_CREATE_REFERAL: "INIT_CREATE_REFERAL",
  INIT_GET_REFERAL: "INIT_GET_REFERAL",
  INIT_UPDATE_VERIFY_STATUS: "INIT_UPDATE_VERIFY_STATUS",
  INIT_ADD_INCOME_INFO: "INIT_ADD_INCOME_INFO",
};
